// TODO WLEF-475 create a dedicated package for custom events
export enum IEvents {
    SEND_TRACKING_EVENT = 'wlefSendEvent',
    SEND_PAGE_VIEW = 'wlefSendPageView',
    SET_DATALAYER = 'wlefSetDatalayer',
}

export type TEventBody = CustomEventInit<{ name: string; data: Record<string, unknown> }>;

export const CustomEventService = {
    fire: (event: IEvents, body?: TEventBody): void => {
        const customEvent = new CustomEvent(event, body);
        window.dispatchEvent(customEvent);
    },
    subscribe: (event: IEvents, listener: EventListener) => {
        window.addEventListener(event, listener);
    },
    unsubscribe: (event: IEvents, listener: EventListener) => {
        window.removeEventListener(event, listener);
    },
};
